var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "isSoldOut_container border-radius-8",
      style: _vm.customStyle,
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSold,
              expression: "isSold",
            },
          ],
          class: _vm.soldImgSize,
        },
        [
          _c("img", {
            attrs: {
              src: require("../../image/global/isSold.png"),
              alt: "img",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("lazy-img", {
        staticClass: "lazy-img",
        attrs: {
          src: _vm.src,
          alt: "",
          background: _vm.background,
          width: _vm.width,
          height: _vm.height,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }